export default "__VITE_ASSET__0382081d__"